import { toast } from "sonner";
import { validateFileSize, validatePdfContent } from "./fileTypes";

export function validateFileSizesWithToast(
  files: File[],
  maxBytes?: number,
): File[] {
  return files.filter((file) => {
    const result = validateFileSize(file, maxBytes);
    if (!result.valid) {
      toast.error(result.error);
      return false;
    }
    return true;
  });
}

export function validateFileSizeWithToast(
  file: File,
  maxBytes?: number,
): boolean {
  const result = validateFileSize(file, maxBytes);
  if (!result.valid) {
    toast.error(result.error);
    return false;
  }
  return true;
}

/**
 * Validates files by size and, for PDFs, by content (a file named `.pdf` must
 * actually contain PDF data). Shows a toast for each rejected file and returns
 * only the files that passed every check.
 */
export async function validateFilesWithToast(
  files: File[],
  maxBytes?: number,
): Promise<File[]> {
  const sizeValidFiles = validateFileSizesWithToast(files, maxBytes);
  const contentResults = await Promise.all(
    sizeValidFiles.map(async (file) => ({
      file,
      validation: await validatePdfContent(file),
    })),
  );
  return contentResults
    .filter(({ validation }) => {
      if (!validation.valid) {
        toast.error(validation.error);
        return false;
      }
      return true;
    })
    .map(({ file }) => file);
}
